import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { hasRouteAccess } from '../auth/route-permissions';
import { authFlowLog } from '../services/auth-flow-log';
import { AuthStore } from '../stores/auth.store';

export const permissionGuard = (route: ActivatedRouteSnapshot): boolean => {
  const authStore = inject(AuthStore);
  const router = inject(Router);

  const routeKey = route.routeConfig?.path ?? '';
  const allowed = hasRouteAccess(routeKey, authStore.tags());

  authFlowLog(environment.debug, '7-guard:permission-check', {
    routeKey,
    roles: authStore.tags(),
    allowed,
  });

  if (allowed) {
    return true;
  }

  void router.navigate(['/403']);
  return false;
};
